import { render, staticRenderFns } from "./UJIPDTEM.vue?vue&type=template&id=2317bdc8&scoped=true"
import script from "./UJIPDTEM.vue?vue&type=script&lang=js"
export * from "./UJIPDTEM.vue?vue&type=script&lang=js"
import style0 from "./UJIPDTEM.vue?vue&type=style&index=0&id=2317bdc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317bdc8",
  null
  
)

export default component.exports